// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `fi-request-access-setting-access-right-filters .RolesCheckBox {
  width: 100%;
}
fi-request-access-setting-access-right-filters .RolesCheckBox .fi-error-message {
  top: -15px;
  margin: 0;
  left: 100px;
}`, "",{"version":3,"sources":["webpack://./Source/app/request-access-setting/access-right-filters/fi-request-access-setting-access-right-filters.scss"],"names":[],"mappings":"AACI;EACI,WAAA;AAAR;AAEQ;EACI,UAAA;EACA,SAAA;EACA,WAAA;AAAZ","sourcesContent":["fi-request-access-setting-access-right-filters {\r\n    .RolesCheckBox {\r\n        width: 100%;\r\n\r\n        .fi-error-message {\r\n            top: -15px;\r\n            margin: 0;\r\n            left: 100px;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
